/**
 * Données des pages villes — SEO Local Luxury Wood
 * Chaque ville a du contenu unique pour éviter le contenu dupliqué
 */

export const cityData = {
  'menuiserie-rabat': {
    slug: 'menuiserie-rabat',
    city: 'Rabat',
    region: 'Rabat-Salé-Kénitra',
    heroImage: 'https://images.unsplash.com/photo-1569383746724-6f1b882b8f46?auto=format&fit=crop&q=80&w=1200',
    lat: 33.9716,
    lng: -6.8498,
    
    // SEO
    titleFr: 'Menuiserie Sur Mesure à Rabat — Luxury Wood Concept',
    titleAr: 'نجارة حسب الطلب في الرباط — لاكشري وود كونسيبت',
    descriptionFr: 'Luxury Wood Concept, votre menuisier sur mesure à Rabat. Cuisines, portes, dressings et aménagement de villas dans les quartiers Hay Riad, Souissi, Agdal, Hassan.',
    descriptionAr: 'لاكشري وود كونسيبت، نجارك المتخصص في الرباط. مطابخ، أبواب، خزائن وتجهيز الفلل في أحياء حي الرياض، السويسي، أكدال، حسان.',
    
    // Contenu
    introFr: `Rabat, capitale du Royaume, est une ville où le raffinement architectural rencontre la modernité. Luxury Wood Concept accompagne les propriétaires de villas et d'appartements dans les quartiers les plus prestigieux de la ville : Hay Riad, Souissi, Agdal, Hassan et l'Océan.

Notre proximité géographique — nous sommes basés à Salé, ville jumelle de Rabat — nous permet d'assurer un suivi rapide et réactif de vos projets. De la conception 3D à l'installation finale, nous gérons chaque étape avec une exigence de qualité absolue.`,
    introAr: `الرباط، عاصمة المملكة، مدينة يلتقي فيها الرقي المعماري بالحداثة. لاكشري وود كونسيبت يرافق أصحاب الفلل والشقق في أرقى أحياء المدينة: حي الرياض، السويسي، أكدال، حسان والمحيط.

قربنا الجغرافي — مقرنا في سلا، المدينة التوأم للرباط — يسمح لنا بضمان متابعة سريعة ومتفاعلة لمشاريعكم. من التصميم ثلاثي الأبعاد إلى التركيب النهائي، ندير كل مرحلة بمتطلبات جودة مطلقة.`,

    // Quartiers ciblés
    neighborhoods: ['Hay Riad', 'Souissi', 'Agdal', 'Hassan', 'L\'Océan', 'Ambassadeurs', 'Témara'],
    
    // Témoignage local
    testimonial: {
      quote: 'Ils ont compris notre vision dès le premier rendez-vous. La cuisine livrée dépasse tout ce qu\'on avait imaginé.',
      name: 'Yasmine El Mansouri',
      role: 'Propriétaire villa — Hay Riad, Rabat',
    },

    // Mots-clés ciblés
    keywords: ['menuiserie rabat', 'menuisier sur mesure rabat', 'cuisine sur mesure rabat', 'porte sur mesure rabat', 'dressing rabat', 'aménagement villa rabat', 'menuisier hay riad', 'cuisine agdal'],
  },

  'menuiserie-casablanca': {
    slug: 'menuiserie-casablanca',
    city: 'Casablanca',
    region: 'Casablanca-Settat',
    heroImage: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?auto=format&fit=crop&q=80&w=1200',
    lat: 33.5731,
    lng: -7.5898,
    
    titleFr: 'Menuiserie Sur Mesure à Casablanca — Luxury Wood Concept',
    titleAr: 'نجارة حسب الطلب في الدار البيضاء — لاكشري وود كونسيبت',
    descriptionFr: 'Menuiserie haut de gamme à Casablanca : cuisines équipées, portes, dressings et aménagement de bureaux à Anfa, Bouskoura, Maarif, CIL et Ain Diab.',
    descriptionAr: 'نجارة فاخرة في الدار البيضاء: مطابخ مجهزة، أبواب، خزائن وتجهيز المكاتب في أنفا، بوسكورة، المعاريف، سيل وعين الذئاب.',
    
    introFr: `Casablanca, capitale économique du Maroc, concentre les projets immobiliers les plus ambitieux du pays. Luxury Wood Concept intervient dans les quartiers résidentiels de prestige — Anfa, Bouskoura Golf City, Californie — ainsi que dans les zones d'affaires pour l'aménagement de bureaux professionnels.

Nos équipes se déplacent régulièrement à Casablanca pour les prises de mesures, les consultations sur site et les installations. Nous assurons le même niveau de qualité et d'exigence que pour nos clients de Rabat-Salé.`,
    introAr: `الدار البيضاء، العاصمة الاقتصادية للمغرب، تجمع أكثر المشاريع العقارية طموحاً في البلاد. لاكشري وود كونسيبت يتدخل في الأحياء السكنية الراقية — أنفا، بوسكورة غولف سيتي، كاليفورنيا — وكذلك في مناطق الأعمال لتجهيز المكاتب المهنية.

فرقنا تتنقل بانتظام إلى الدار البيضاء لأخذ القياسات، الاستشارات الميدانية والتركيبات. نضمن نفس مستوى الجودة والمتطلبات كما لعملائنا في الرباط-سلا.`,

    neighborhoods: ['Anfa', 'Maarif', 'Bouskoura', 'CIL', 'Ain Diab', 'Californie', 'Gauthier', '2 Mars'],
    
    testimonial: {
      quote: 'Professionnalisme absolu. Nos bureaux ont été entièrement transformés, dans les délais et avec un résultat haut de gamme.',
      name: 'Mehdi Bennani',
      role: 'Directeur général — Anfa, Casablanca',
    },

    keywords: ['menuiserie casablanca', 'menuisier sur mesure casablanca', 'cuisine sur mesure casablanca', 'aménagement bureau casablanca', 'porte sur mesure casa', 'dressing casablanca', 'menuisier anfa', 'cuisine maarif'],
  },

  'menuiserie-marrakech': {
    slug: 'menuiserie-marrakech',
    city: 'Marrakech',
    region: 'Marrakech-Safi',
    heroImage: 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&q=80&w=1200',
    lat: 31.6295,
    lng: -7.9811,
    
    titleFr: 'Menuiserie de Luxe à Marrakech — Luxury Wood Concept',
    titleAr: 'نجارة فاخرة في مراكش — لاكشري وود كونسيبت',
    descriptionFr: 'Menuiserie de luxe à Marrakech : aménagement de villas, riads et hôtels. Expertise spécifique bois noble et design marocain contemporain dans la ville ocre.',
    descriptionAr: 'نجارة فاخرة في مراكش: تجهيز الفلل والرياضات والفنادق. خبرة متخصصة في الخشب النبيل والتصميم المغربي المعاصر في المدينة الحمراء.',
    
    introFr: `Marrakech, la perle du Sud, est une destination mondiale du luxe et de l'art de vivre. Luxury Wood Concept apporte son expertise artisanale aux villas de prestige de la Palmeraie, aux riads historiques de la Médina et aux projets hôteliers d'envergure.

Notre savoir-faire s'adapte parfaitement à l'esthétique marrakchie — le mariage du bois noble avec les zellige, le tadelakt et les moucharabiehs. Nous créons des espaces qui honorent le patrimoine tout en embrassant la modernité.`,
    introAr: `مراكش، لؤلؤة الجنوب، وجهة عالمية للرفاهية وفن العيش. لاكشري وود كونسيبت يجلب خبرته الحرفية لفلل النخيل الفاخرة، والرياضات التاريخية في المدينة القديمة، والمشاريع الفندقية الكبرى.

معرفتنا تتكيف تماماً مع الجمالية المراكشية — زواج الخشب النبيل مع الزليج والتادلاكت والمشربيات. نصنع فضاءات تكرم التراث مع احتضان الحداثة.`,

    neighborhoods: ['Palmeraie', 'Guéliz', 'Médina', 'Targa', 'Route de l\'Ourika', 'Amelkis', 'Route de Fès'],
    
    testimonial: {
      quote: 'Notre appartement à Marrakech a été métamorphosé. La qualité des matériaux et le souci du détail font vraiment la différence.',
      name: 'Sofia Lahlou',
      role: 'Architecte d\'intérieur — Guéliz, Marrakech',
    },

    keywords: ['menuiserie marrakech', 'menuisier sur mesure marrakech', 'aménagement villa marrakech', 'riad marrakech bois', 'cuisine marrakech', 'porte bois marrakech', 'menuisier palmeraie'],
  },

  'menuiserie-tanger': {
    slug: 'menuiserie-tanger',
    city: 'Tanger',
    region: 'Tanger-Tétouan-Al Hoceïma',
    heroImage: 'https://images.unsplash.com/photo-1553899017-c399e3ce1bab?auto=format&fit=crop&q=80&w=1200',
    lat: 35.7595,
    lng: -5.8340,
    
    titleFr: 'Menuiserie Sur Mesure à Tanger — Luxury Wood Concept',
    titleAr: 'نجارة حسب الطلب في طنجة — لاكشري وود كونسيبت',
    descriptionFr: 'Menuiserie haut de gamme à Tanger : aménagement de villas, appartements de luxe et projets hôteliers. Accompagnement des grands projets immobiliers du Nord du Maroc.',
    descriptionAr: 'نجارة فاخرة في طنجة: تجهيز الفلل والشقق الفاخرة والمشاريع الفندقية. مرافقة المشاريع العقارية الكبرى في شمال المغرب.',
    
    introFr: `Tanger, porte de l'Afrique sur l'Europe, connaît un essor immobilier spectaculaire. Luxury Wood Concept accompagne les promoteurs et les propriétaires privés dans cette ville en pleine transformation. Des résidences de Malabata aux villas de Cap Spartel, nous apportons notre signature d'excellence.

La croissance du secteur hôtelier et des résidences de prestige à Tanger offre de nombreuses opportunités pour des aménagements sur mesure haut de gamme.`,
    introAr: `طنجة، بوابة أفريقيا على أوروبا، تشهد نمواً عقارياً مذهلاً. لاكشري وود كونسيبت يرافق المطورين والملاك الخاصين في هذه المدينة المتحولة. من إقامات مالاباتا إلى فلل كاب سبارتيل، نجلب توقيعنا للتميز.

نمو القطاع الفندقي والإقامات الفاخرة في طنجة يوفر فرصاً عديدة للتجهيزات الفاخرة حسب الطلب.`,

    neighborhoods: ['Malabata', 'Cap Spartel', 'Tanger Ville', 'Boubana', 'Médina', 'Marchane'],
    
    testimonial: {
      quote: 'Un résultat à la hauteur de nos attentes pour un projet ambitieux. L\'équipe a fait le déplacement depuis Salé avec un professionnalisme remarquable.',
      name: 'Karim Lahrichi',
      role: 'Promoteur immobilier — Tanger',
    },

    keywords: ['menuiserie tanger', 'menuisier sur mesure tanger', 'aménagement villa tanger', 'cuisine tanger', 'menuisier nord maroc'],
  },

  'menuiserie-sale': {
    slug: 'menuiserie-sale',
    city: 'Salé',
    region: 'Rabat-Salé-Kénitra',
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=1200',
    lat: 34.0531,
    lng: -6.8003,
    
    titleFr: 'Menuiserie Sur Mesure à Salé — Luxury Wood Concept (Siège Social)',
    titleAr: 'نجارة حسب الطلب في سلا — لاكشري وود كونسيبت (المقر الرئيسي)',
    descriptionFr: 'Siège social de Luxury Wood Concept à Salé. Atelier de fabrication et showroom. Cuisines, portes, dressings sur mesure. Visite de l\'atelier sur rendez-vous.',
    descriptionAr: 'المقر الرئيسي للاكشري وود كونسيبت في سلا. ورشة تصنيع ومعرض. مطابخ، أبواب، خزائن حسب الطلب. زيارة الورشة بموعد.',
    
    introFr: `Salé abrite le siège social et l'atelier de fabrication de Luxury Wood Concept. C'est ici, au 18 Lot Zerdal, Bouknadel, que nos artisans menuisiers transforment le bois noble en pièces d'exception.

En tant que client de Salé, vous bénéficiez d'un avantage unique : la proximité directe avec notre atelier. Vous pouvez visiter notre showroom, suivre la fabrication de votre projet et échanger directement avec nos artisans. Un suivi personnalisé du début à la fin.`,
    introAr: `سلا تحتضن المقر الرئيسي وورشة تصنيع لاكشري وود كونسيبت. هنا، في 18 لوت زردال، بوقنادل، يحول حرفيونا الخشب النبيل إلى قطع استثنائية.

كعميل في سلا، تستفيد من ميزة فريدة: القرب المباشر من ورشتنا. يمكنك زيارة معرضنا، متابعة تصنيع مشروعك والتبادل مباشرة مع حرفيينا. متابعة شخصية من البداية إلى النهاية.`,

    neighborhoods: ['Bouknadel', 'Sala Al Jadida', 'Hay Essalam', 'Tabriquet', 'Bettana', 'Laâyayda'],
    
    testimonial: {
      quote: 'L\'avantage d\'être à côté de l\'atelier : on a pu suivre chaque étape et ajuster les détails en temps réel.',
      name: 'Ahmed Tazi',
      role: 'Propriétaire — Bouknadel, Salé',
    },

    keywords: ['menuiserie salé', 'menuisier salé', 'atelier menuiserie salé', 'cuisine sur mesure salé', 'porte bois salé', 'menuisier bouknadel'],
  },
};

export default cityData;
